var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboard = function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.25 3.5A3.75 3.75 0 0 0 3.5 7.25v9.5a3.75 3.75 0 0 0 3.75 3.75h9.5a3.75 3.75 0 0 0 3.75-3.75v-9.5a3.75 3.75 0 0 0-3.75-3.75zM5 7.25A2.25 2.25 0 0 1 7.25 5h9.5A2.25 2.25 0 0 1 19 7.25v9.5A2.25 2.25 0 0 1 16.75 19h-9.5A2.25 2.25 0 0 1 5 16.75zM8.25 15a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-1.5 0zm3.75.75a.75.75 0 0 1-.75-.75V9.5a.75.75 0 0 1 1.5 0V15a.75.75 0 0 1-.75.75m2.25-.75a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-1.5 0z",
    clipRule: "evenodd"
  })));
};
export default SvgDashboard;